import React, { useEffect, useState } from 'react'
import { Box, ToastInfoIconWMO } from '@usap/uicomponents'
import { partsWithVideos } from './constant'
import ReturnItemDetail from './component/ItemDetail'
import {
  ParentSku, DisplayVideoLightBox,
} from './component'
import { Container } from '../style/RMAReturnItemInfoWMO.css'
import ItemImageWMO from './component/ItemImageWMO'
import ReturnStatusWMO from '../../../ReturnStatusWMO'
import ComputeQtyCheckboxWMO from './component/ComputeQtyCheckboxWMO'
import UserInfoMsgWMO from '../../../../common/UserInfoMsgWMO'
import { checkReturnEligibility } from '@usap/carparts/src/shared/helpers'

const RMAReturnItemInfoWMO = props => {
  const {
    showTabs,
    isDesktop,
    imageHeight,
    removeQtySelect,
    isBot,
    selectedPart,
    isMultiplePart,
    Link,
    setDisplayReturnDetails,
    setReturnDetailsData,
    creditStatus,
    returnRequestStatus,
    orderInfo = {},
    parts,
    ikey = 0,
    handleQtyChange,
    etaToShow,
    handleChange,
    showVideo,
    setShowVideo,
    returnStatusData,
    imageText,
    imageUrlSrc,
    orderItems,
    returnItemQty,
    displayNull,
    showCheckBox,
    itemTotal,
    qtyRange,
    eligibleRMA,
    qtyToCompute,
    itemPriceParsed,
    selectedQty,
    multipleItemsPresent,
    setPartReturnEligibilityList,
  } = props

  const {
    order_item_id: itemOrderId,
    parentSku,
    brandText,
    sku: partNumber,
    productText,
    order_item_status,
  } = parts

  const isPartCancelled = order_item_status == 'Canceled' || order_item_status == 'Cancelled';
  const isReturnInitiated = parts?.returnRequest && parts?.returnRequest?.return_request_id != '';

  const { eligible: itemEligibleForReturnWindow, message: returnUnavailableMsg } =
    checkReturnEligibility(parts);

  const itemUniqueIdentifier = `${partNumber}_${ikey}`;

  useEffect(() => {
    setPartReturnEligibilityList((prevState) => ({
      ...prevState,
      [itemUniqueIdentifier]: itemEligibleForReturnWindow && !isReturnInitiated && !isPartCancelled,
    }));
  }, [itemEligibleForReturnWindow, isReturnInitiated, isPartCancelled]);

  // If part is Cancelled, or if Return is already Initiated, don't show the return-window-expired toast message.
  const showReturnWindowExpired = !isReturnInitiated && !isPartCancelled && !itemEligibleForReturnWindow;
  const [isItemSelected, setIsItemSelected] = useState(false);

  return (
    <>
      <Container style={{border: `1px solid ${multipleItemsPresent && isItemSelected ? '#3E3E47' : '#D4D4D6'}`}}>
        { showReturnWindowExpired && <UserInfoMsgWMO infoType={returnUnavailableMsg} bgColor={'#939398'} icon={ToastInfoIconWMO} style={{marginBottom: '24px'}} textStyle={{fontWeight: 700}}/> }
        <Box direction="row" width={'100%'} style={showReturnWindowExpired ? { opacity: 0.5 } : null}>
          { !showReturnWindowExpired && <ComputeQtyCheckboxWMO
            isMultiplePart={isMultiplePart}
            itemOrderId={itemOrderId}
            showCheckBox={showCheckBox}
            handleChange={handleChange}
            qtyToCompute={qtyToCompute}
            multipleItemsPresent={multipleItemsPresent}
            setIsItemSelected={setIsItemSelected}
          /> }
          <ItemImageWMO
            imageHeight={imageHeight}
            itemOrderId={itemOrderId}
            eligibleRMA={eligibleRMA}
            imageUrlSrc={imageUrlSrc}
            imageText={imageText}
            multipleItemsPresent={multipleItemsPresent}
          />
          <ReturnItemDetail
            isDesktop={isDesktop}
            orderItems={orderItems}
            eligibleRMA={eligibleRMA}
            brandText={brandText}
            selectedPart={selectedPart}
            partNumber={partNumber}
            showTabs={showTabs}
            removeQtySelect={removeQtySelect}
            ikey={ikey}
            qtyRange={qtyRange}
            qtyToCompute={qtyToCompute}
            handleQtyChange={handleQtyChange}
            returnItemQty={returnItemQty}
            itemPriceParsed={itemPriceParsed}
            selectedQty={selectedQty}
            showCheckBox={showCheckBox}
            imageText={imageText}
            itemTotal={itemTotal}
            parentSku={parentSku}
            etaToShow={etaToShow}
            returnStatusData={returnStatusData}
            orderInfo={orderInfo}
            Link={Link}
            creditStatus={creditStatus}
            returnRequestStatus={returnRequestStatus}
            setReturnDetailsData={setReturnDetailsData}
            setDisplayReturnDetails={setDisplayReturnDetails}
            multipleItemsPresent={multipleItemsPresent}
            itemEligibleForReturnWindow={itemEligibleForReturnWindow}
          />
        </Box>
        <ParentSku
          selectedPart={selectedPart}
          displayNull={displayNull}
          eligibleRMA={eligibleRMA}
          parentSku={parentSku}
          showTabs={showTabs}
          isDesktop={isDesktop}
          isWmoEnabled
          multipleItemsPresent={multipleItemsPresent}
        />
        {!isDesktop && etaToShow}
        {!isDesktop && returnStatusData && (
          <ReturnStatusWMO
            returnStatusData={returnStatusData}
            orderDetails={orderInfo}
            Link={Link}
            creditStatus={creditStatus}
            returnRequestStatus={returnRequestStatus}
            setReturnDetailsData={setReturnDetailsData}
            setDisplayReturnDetails={setDisplayReturnDetails}
            isDesktop={isDesktop}
          />
        )}
      </Container>
      <Box margin={{ top: '16px' }}>
        <DisplayVideoLightBox
          displayNull={displayNull}
          isBot={isBot}
          showVideo={showVideo}
          setShowVideo={setShowVideo}
          productText={productText}
          partsWithVideos={partsWithVideos}
          selectedPart={selectedPart}
        />
      </Box>
    </>
  )
}

export default RMAReturnItemInfoWMO
